import { SignInButton } from "../components/SignInButton/";
import { HeadingLarge, HeadingMedium, LabelMedium, ParagraphMedium } from "baseui/typography";
import { Block } from "baseui/block";
import { useStyletron } from "baseui";
import { FormattedMessage } from "react-intl";
import { VscSettings } from "react-icons/vsc";

export const LoginPage = () => {
  const [, theme] = useStyletron();

  return (
    <Block width="100%" height="100%">
      <Block display="flex" flexDirection="column" alignItems="center" marginTop="100px">
        <ParagraphMedium marginBottom={0}>
          <FormattedMessage id="login.welcome" defaultMessage="Welcome to the" />{" "}
        </ParagraphMedium>

        <HeadingLarge>
          <Block display="inline">
            <Logo
              style={{
                marginBottom: "-12px",
                marginLeft: "15px",
                fill: theme.colors.primary,
              }}
              width={120}
            />
            .bos
          </Block>
        </HeadingLarge>
        <HeadingMedium marginTop={0}>
          <VscSettings />
          <FormattedMessage id="SubscriptionAdministration" defaultMessage={"Subscription Administration"} />
        </HeadingMedium>
        <ParagraphMedium marginBottom="50px">
          <FormattedMessage id="login.info" defaultMessage="you need to sign-in to proceed." />
        </ParagraphMedium>
        <SignInButton />
        <LabelMedium marginTop="50px">#digitalbuilding</LabelMedium>
      </Block>
    </Block>
  );
};

const Logo = (props: any) => {
  return (
    <svg
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0, 0, 400,161.23662306777646">
      <g id="svgg">
        <path
          id="path0"
          d="M290.131 18.955 C 290.131 37.832,290.126 37.916,289.059 39.500 C 286.144 43.826,282.499 44.048,276.263 40.281 C 239.827 18.272,195.544 49.313,204.261 90.752 C 213.465 134.507,273.439 141.682,293.635 101.445 C 298.434 91.883,298.683 88.835,298.688 39.596 L 298.692 0.000 294.411 0.000 L 290.131 0.000 290.131 18.955 M41.498 33.292 C 3.479 38.657,-13.232 84.784,12.721 112.725 C 42.390 144.665,95.433 123.883,95.273 80.380 C 95.167 51.491,69.820 29.296,41.498 33.292 M141.946 33.508 C 112.221 38.127,94.348 68.679,104.674 97.217 C 114.962 125.648,150.060 137.053,175.765 120.318 C 180.586 117.179,184.459 117.465,187.285 121.170 L 188.585 122.874 188.719 142.055 L 188.854 161.237 192.881 161.237 L 196.908 161.237 196.908 118.731 C 196.908 71.702,196.912 71.774,193.872 63.679 C 185.967 42.635,164.285 30.036,141.946 33.508 M345.898 33.292 C 314.121 37.776,295.587 71.754,309.141 100.677 C 325.736 136.091,375.734 137.492,394.305 103.062 C 412.583 69.176,383.960 27.921,345.898 33.292 M56.837 42.097 C 88.964 50.296,98.073 91.299,72.255 111.500 C 46.152 131.924,8.337 113.329,8.496 80.148 C 8.616 55.152,32.948 36.001,56.837 42.097 M154.425 41.410 C 186.021 45.707,199.922 84.127,178.259 107.285 C 156.176 130.892,116.974 119.734,110.558 88.015 C 105.310 62.076,128.129 37.834,154.425 41.410 M260.404 42.310 C 289.999 49.796,300.213 86.793,278.640 108.366 C 255.389 131.617,215.971 118.023,211.609 85.251 C 209.024 65.825,222.538 46.567,241.855 42.150 C 248.291 40.679,254.154 40.729,260.404 42.310 M361.969 42.303 C 389.984 49.641,401.052 83.552,382.664 105.711 C 359.226 133.955,312.941 117.321,312.964 80.661 C 312.980 54.842,337.265 35.833,361.969 42.303 "
          stroke="none"
        />
      </g>
    </svg>
  );
};
